import { render, staticRenderFns } from "./RequestCommentaryDialog.vue?vue&type=template&id=4628909c&scoped=true"
import script from "./RequestCommentaryDialog.vue?vue&type=script&lang=js"
export * from "./RequestCommentaryDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestCommentaryDialog.vue?vue&type=style&index=0&id=4628909c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628909c",
  null
  
)

export default component.exports